<template>
  <div class="part table tasks-list animated fadeIn">
    <template v-if="loading">
      <ListSkeleton :list="9"></ListSkeleton>
    </template>
    <template v-else>
      <a-table
        v-if="isVaild"
        :columns="columns"
        :dataSource="tasks"
        :rowKey="(record, index) => record._id"
        :scroll="{ x: 900 }"
        :pagination="pagination"
        @change="change"
      >
        <span slot="urgent" slot-scope="urgent">
          <i class="fa fa-star" v-if="urgent"> </i>
          <i class="fa fa-star-o" v-else> </i>
        </span>

        <span slot="deadline" slot-scope="deadline">
          {{ deadline | moment('l') }}
        </span>

        <span slot="progress" slot-scope="progress">
          <span class="badge badge-primary"> {{ progress }}</span>
        </span>

        <span slot="participants" slot-scope="participants">
          <div class="names-group d-flex flex-column">
            <div v-for="participant in participants" :key="participant._id">
              <a-icon type="user" />
              {{ participant.display_name }}
            </div>
          </div>
        </span>

        <span slot="types" slot-scope="types">
          <span class="tag mr-1" v-for="type in types" :key="type">
            {{ type | CAPITALIZE_ }}
          </span>
        </span>

        <span slot="description" slot-scope="description">
          <div class="sticker">
            {{ description }}
          </div>
        </span>

        <span slot="created_at" slot-scope="created_at">
          {{ created_at | moment('l') }}
        </span>
      </a-table>
      <div class="empty" v-else>
        <a-empty></a-empty>
      </div>
    </template>
  </div>
</template>

<script>
import ListSkeleton from '../skeleton/ListSkeleton.vue'

const KEY = 'tasks'

export default {
  components: {
    ListSkeleton,
  },
  name: 'table-tasks',
  props: ['tasks', 'pagination', 'loading'],

  data() {
    return {
      columns: [
        {
          title: 'No',
          key: 'no',
          width: '60px',
          align: 'center',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '★',
          dataIndex: 'urgent',
          key: 'urgent',
          width: '40px',
          align: 'center',
          fixed: 'left',
          scopedSlots: { customRender: 'urgent' },
        },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          width: '220px',
          customRender: (text, record, index) => {
            return text
          },
        },

        {
          title: 'Deadline',
          dataIndex: 'deadline',
          key: 'deadline',
          width: '100px',
          scopedSlots: { customRender: 'deadline' },
        },

        {
          title: 'Progress',
          dataIndex: 'progress',
          key: 'progress',
          width: '90px',
          align: 'center',
          scopedSlots: { customRender: 'progress' },
        },
        {
          title: 'Participants',
          dataIndex: 'participants',
          key: 'participants',
          width: '160px',
          align: 'center',
          scopedSlots: { customRender: 'participants' },
        },

        {
          title: 'Types',
          dataIndex: 'types',
          key: 'types',
          scopedSlots: { customRender: 'types' },
        },

        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description',
          scopedSlots: { customRender: 'description' },
        },
        {
          title: 'Creation',
          dataIndex: 'created_at',
          key: 'created_at',
          width: '100px',
          scopedSlots: { customRender: 'created_at' },
        },
      ],
    }
  },
  methods: {
    onEdit(id) {
      router.push({ name: 'staff-detail', params: { id } })
    },
    change: (pagination, filters, sorter) => {
      store.dispatch('pm/updateQuery', { key: KEY, query: { pagination, filters, sorter } })
    },
  },
  computed: {
    isVaild() {
      return this.tasks && Array.isArray(this.tasks) && this.tasks.length > 0
    },
  },
  mounted() {
    // console.log(this.tasks)
  },
}
</script>

<style lang="scss" scoped>
.table.tasks-list {
  .tag {
    text-decoration: underline;
  }
  .sticker {
    background: #ffeb3b;
    padding: 2px 8px;
    color: #000;
    border-radius: 3px;
    font-size: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    box-shadow: 0 0 10px #eee;
  }

  .empty {
    min-height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
